var $1be0a98038a2c09b$exports = {};
$1be0a98038a2c09b$exports = {
    "endTime": `\u{427}\u{430}\u{441} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44F}`,
    "startTime": `\u{427}\u{430}\u{441} \u{43F}\u{43E}\u{447}\u{430}\u{442}\u{43A}\u{443}`,
    "time": `\u{427}\u{430}\u{441}`
};


export {$1be0a98038a2c09b$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
